import { Hero } from "@/components/landing/Hero";
import { Spaces } from "@/components/landing/Spaces";
import { Hours } from "@/components/landing/Hours";
import { HowItWorks } from "@/components/landing/HowItWorks";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Hero />
      <Spaces />
      <Hours />
      <HowItWorks />
    </main>
  );
}
